import { useCalendar } from "~/store/calendar";
import { useUserStore } from "~/store/auth";
import { roles } from "~/composables/roles";

export default defineNuxtPlugin(() => {
  const calendar = useCalendar();
  calendar.initializeCalendar();

  // Global: para roles técnicos y subcontrata no habitual, la semana por defecto
  // debe ser la actual del navegador. El auth middleware rehidrata el store desde
  // localStorage, así que reaccionamos cuando el rol ya está disponible.
  if (!import.meta.client) return;

  const userStore = useUserStore();
  let applied = false;

  const maybeApplyCurrentWeekDefault = () => {
    if (applied) return;
    const userRole = userStore.getUserRole;
    if (!userRole) return;

    const isTechnicalRole =
      userRole === roles.technician ||
      userRole === roles.GMAOSupport ||
      userRole === roles.queries;

    if (isTechnicalRole || userRole === roles.regularSubcontractor) {
      calendar.setCalendarToday();
      applied = true;
    }
  };

  maybeApplyCurrentWeekDefault();
  watch(
    () => userStore.getUserRole,
    () => {
      maybeApplyCurrentWeekDefault();
    }
  );
});
